import AuthAxios from "./AxiosAuth";

export function fetchGetJson(url) {
  return AuthAxios.get(url).then((res) => {
    return res.data;
  });
}

export function fetchPostJson(url, requestBody) {
  return AuthAxios.post(url, requestBody)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response?.data;
    });
}

export function fetchDeleteJson(url) {
  return AuthAxios.delete(url)
    .then((_results) => {
      return true;
    })
    .catch((_error) => {
      return false;
    });
}
